import React, { useCallback, useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import LocationState from '../../../auth/LocationState';
import { Alert, Button, Card, Form, Input, Modal, Typography, Row, Col, Grid } from 'antd';
// import { EyeFilled, EyeInvisibleOutlined } from '@ant-design/icons';
import eyeOpen from 'assets/images/show-3.svg';
import eyeClose from 'assets/images/show-2.svg';
// import { getConfig } from 'configs';
import { PrimaryButton } from 'components';
import { SessionStorageKey, sessionStorageService } from 'utils/SessionStorageService';
import { localStorageService } from 'utils/LocalStorageService';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { revalidateAntdFormLanguageChanged } from '../../../i18n';
import { useGetSystemMessage, useSystemUnavailSetting, useValidMfa } from 'all-in-one-shared-api';
import _ from 'lodash';
// import GoogleCaptcha from '../../../components/googleCaptcha';
import * as DOMPurify from 'dompurify';
import ReactHtmlParser from 'react-html-parser';
// import { useCheckAdminLoggedIn } from 'hooks/useCheckAdminLoggedIn';
import { useKeycloakReady } from 'hooks';
import { osName, osVersion } from 'react-device-detect';
// import img from 'src/assets/images/loginBackgroundImage2.png';
import { isLocaleEnglish } from 'utils/languageUtils';
// import { removeCookie } from 'utils/cookies';
const { useBreakpoint } = Grid;
import './loginstyle.less';
import { setErrorCodeFun } from 'utils';

type DirectLoginFormData = {
  emailId: string;
  password: string;
};

function LoginPage() {
  const isBiology = false;
  const { t } = useTranslation();

  return (
    <Row
      gutter={[16, 16]}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // padding: '0 80px',
        width: '100%',
        height: '100%',
        backgroundColor: 'transparent',
        marginTop: 48,
      }}
    >
      <Col xs={24} sm={24} md={12} style={{ display: 'flex', justifyContent: 'center' }}>
        <div
          style={{
            width: '100%',
            textAlign: 'center',
            height: '100%',
            backgroundColor: 'transparent',
          }}
        >
          <div style={{ fontSize: 30, fontFamily: 'Roboto400', color: 'white', textAlign: 'center' }}>
            {isBiology ? 'Hi, John!' : t('login.nonesalutation')}
          </div>
          <div style={{ fontSize: 17, fontFamily: 'Roboto400', color: 'white', textAlign: 'center' }}>
            {isBiology ? 'Welcome back' : t('life.login.welcomeSub')}
          </div>
          {/* <LaunchCarousel /> */}
        </div>
      </Col>
      <Col xs={24} sm={24} md={12} style={{ display: 'flex', justifyContent: 'center', height: '100%' }}>
        {/* <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: 'transparent',
          }}
        > */}
        <LoginContent />
        {/* </div> */}
      </Col>
    </Row>
  );
}

// const config = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'mock');

function LoginContent() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { keycloak, tokenParsed, initialized } = useKeycloakReady();
  const isEnglish = isLocaleEnglish(i18n.language);
  // const ERROR_UNKNOWN = 'unknown_error';
  // const INVALID_GRANT = 'invalid_grant';
  const { lg } = useBreakpoint();
  const [showError, setShowError] = useState(false);

  keycloak.onAuthError = (error) => {
    if (!showError) return;
    setLoginFailCount((count) => count + 1);
    if (error.error === 'auth.admin.password.expired') {
      setIsAdminModalOpen(true);
      return;
    }
    setSnackbarMessage(error?.error);
    if (error?.error === 'unknown_error') {
      setSnackbarMessage('auth.login.generic');
      if (loginFailCount < 2) {
        form.submit();
        return;
      }
    }
    if (error?.error === 'invalid_grant') {
      setSnackbarMessage('auth.login.invalidGrant');
    }
    if (error?.error === 'auth.login.fails.exceeded') {
      setSnackbarMessage('auth.login.fails.exceeded');
    }
    if (error?.error === 'Network Error') {
      setSnackbarMessage('auth.login.networkError');
    }
    if (error?.error === 'auth.login.personal.no.active.policy.found') {
      setSnackbarMessage('auth.login.personal.no.active.policy.found');
    }

    setOpenSnackbar(true);
  };
  const [visible, setVisible] = useState(false);
  const [loginFailCount, setLoginFailCount] = React.useState(0);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  // const [isCaptchaVerified, setCaptchaVerified] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [isLoading, setLoading] = React.useState(false);
  const [form] = Form.useForm();
  sessionStorageService.remove(SessionStorageKey.RegisterData);
  const { data: systemMessages } = useGetSystemMessage({ stop: true });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAdminModalOpen, setIsAdminModalOpen] = useState(false);
  const [popUp, setPopUp] = useState(false);
  const [randoms, setRandoms] = useState(Math.random());
  const [openFetch] = useState(true);
  const { shouldFetch, data } = useSystemUnavailSetting('useSystemUnavailSetting' + randoms);
  // const { from, setfrom } = useState<string>('');
  // const isAdminLoggedIn = useCheckAdminLoggedIn();
  const from: string = (location.state as LocationState)?.from?.pathname.includes('eob')
    ? (location.state as LocationState)?.from?.pathname
    : tokenParsed && tokenParsed.ebClientKey != ''
    ? '/home'
    : '/LIHome';
  useEffect(() => {
    if (systemMessages && systemMessages?.length > 0) {
      setIsModalOpen(true);
    }
  }, [systemMessages]);
  // useEffect(() => {
  //   setfrom(
  //     (location.state as LocationState)?.from?.pathname.includes('eob')
  //       ? (location.state as LocationState)?.from?.pathname
  //       : tokenParsed?.ebClientKey != ''
  //       ? '/home'
  //       : '/LIHome',
  //   );
  // }, [tokenParsed]);
  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [i18n.language, form]);
  useEffect(() => {
    if (openFetch) {
      setPopUp(false);
      setRandoms(Math.random());
      shouldFetch(true);
    }
  }, [i18n.language, shouldFetch, openFetch]);
  useEffect(() => {
    setPopUp(false);
    if (data && data.webPlatform && data.webPlatform.mesgEn) {
      setPopUp(true);
    } else {
      setPopUp(false);
    }
  }, [data]);
  useEffect(() => {
    // if ((location.state as LocationState)?.password) {
    //   form.resetFields(['password']);
    //   form.setFieldValue('password', '');
    // }
  }, [location.state]);
  useEffect(() => {
    const layout = document.querySelector('.ant-layout');
    if (popUp) {
      const mask = document.createElement('div');
      mask.className = 'mask_custom';
      mask.style.position = 'fixed';
      mask.style.height = '100%';
      mask.style.width = '100%';
      mask.style.top = '0';
      mask.style.left = '0';
      mask.style.zIndex = '130';
      mask.style.backgroundColor = 'rgba(0,0,0,.3)';
      mask.style.display = 'flex'; // 使用 flex 布局
      mask.style.justifyContent = 'center'; // 水平居中
      mask.style.alignItems = 'center'; // 垂直居中

      const content = document.createElement('div');
      content.style.background = 'white';
      content.style.paddingLeft = '24px';
      content.style.paddingRight = '24px';
      content.style.paddingTop = '14px'; // 上方留出空间
      // content.style.paddingBottom = '10px'; // 下方留出空间
      content.style.borderRadius = '8px';
      content.style.height = 'auto'; // 根据内容调整高度
      content.style.width = lg ? 'auto' : '80%'; // 给定宽度
      content.style.margin = '0 auto'; // 给定宽度
      if (lg) content.style.transform = 'translateY(-50%)';
      // content.style.textAlign = 'center'; // 让内容居中

      const noteText = document.createElement('p');
      noteText.style.fontFamily = 'Roboto400';
      noteText.style.fontSize = '17px';
      noteText.style.color = '#420252B';
      // noteText.style.marginTop = '16px'; // 增加下边距
      noteText.style.marginBottom = '16px'; // 增加下边距
      // noteText.innerHTML = t('life.home.tooltipBefore', { link: 'https://www.baidu.com/?tn=54093922_50_hao_pg' });
      noteText.innerHTML = (isEnglish ? data?.webPlatform?.mesgEn : data?.webPlatform?.mesgTc) || '';
      const aContent = noteText.querySelector('a');
      if (aContent) {
        aContent.style.color = '#0055CC';
        aContent.style.textDecoration = 'underline';
      }
      // content.appendChild(noteText);
      // mask.appendChild(content);
      // const fragment = document.createDocumentFragment();
      // fragment.appendChild(mask);
      // document.body.appendChild(fragment);
      // document.body.appendChild(mask);
      setTimeout(function () {
        if (layout) layout.classList.add('filter-style');
        content.appendChild(noteText);
        mask.appendChild(content);
        document.body.appendChild(mask);
      }, 0);
    } else {
      if (layout) layout.classList.remove('filter-style');
    }
  }, [popUp, t, i18n.language, navigate, isEnglish, data, lg]);

  // Thuy's Note: escape from login page when keycloak authenticated
  // Andy's Note: only redirect to home page when keycloak authenticated and firstLogin is false - AIOBRB-2071
  useEffect(() => {
    // removeCookie('KeycloakTokens');
    const genbravoSessionFlag = sessionStorageService.get('genbravoSessionFlag');
    // if (keycloak.authenticated && tokenParsed?.firstLogin === 'false') {
    if (genbravoSessionFlag && keycloak.authenticated && tokenParsed?.firstLogin === 'false') {
      navigate(from, { replace: true });
    }
  }, [keycloak.authenticated, tokenParsed?.firstLogin, navigate, from]);

  // const isShowCaptcha = loginFailCount >= 3;
  // console.log((window.crypto as Crypto & { randomUUID: () => string }).randomUUID(), 22222222222222);
  useEffect(() => {
    if (!localStorageService.get('deviceId')) {
      localStorageService.set('deviceId', (window.crypto as Crypto & { randomUUID: () => string }).randomUUID());
    }
  }, []);

  const { shouldFetch: shouldValidMfa } = useValidMfa(
    'useValidMfa',
    form.getFieldValue('username')?.trim(),
    form.getFieldValue('password'),
    localStorageService.get('deviceId') ?? '',
    'WEB',
    'LO_LOGIN',
    {
      onSuccess: (validateResponse) => {
        shouldValidMfa(false);
        if (validateResponse) {
          if (validateResponse.mfaOtpFlag == 'Y')
            navigate('/mfaOtp', {
              state: {
                loginId: form.getFieldValue('username').trim(),
                email: validateResponse.mfaEmail,
                mobile: validateResponse.mfaMobile,
                password: form.getFieldValue('password'),
                from: (location.state as LocationState)?.from?.pathname,
                accountType: validateResponse.accountType,
              },
            });
          else
            keycloak
              .login({
                username: form.getFieldValue('username').trim(),
                password: form.getFieldValue('password'),
                device: osName,
                deviceVersion: osVersion,
                deviceId: localStorageService.get('deviceId'),
                loginMethod: 'LO_LOGIN',
                loginPlatform: 'WEB',
              })
              .then(() => {
                sessionStorageService.set('genbravoSessionFlag', new Date().getTime().toString());
                navigate(from, { replace: true });
              })
              .catch(() => {
                // Please handle error of login in the keycloak.onAuthError
              })
              .finally(() => {
                setLoading(false);
              });
        }
      },
      onError: (error) => {
        if (error) {
          console.log(error.code, error.message, 'error');
          shouldValidMfa(false);
          setLoading(false);
          if (error.code === 'auth.admin.password.expired') {
            setIsAdminModalOpen(true);
            return;
          }
          const message = setErrorCodeFun(error.code, i18n.language);
          setSnackbarMessage(message ?? (t(error.code) !== error.code ? t(error.code) : 'auth.login.networkError'));
          setOpenSnackbar(true);
        }
      },
    },
  );
  const onSubmit = useCallback(
    async (formData: DirectLoginFormData, event?: React.BaseSyntheticEvent) => {
      setShowError(true);
      event && event.preventDefault();
      // setLoading(true);

      if (!initialized) return;
      shouldValidMfa(true);
    },
    [initialized, shouldValidMfa],
  );

  // const handleCloseSnackbar = () => {
  //   setOpenSnackbar(false);
  // };

  const onFinish = (values: { username: string; password: string }) => {
    onSubmit({ emailId: values.username, password: values.password });
  };

  // const onCaptchaError = () => {
  //   setCaptchaVerified(false);
  // };

  const renderSystemMessage = () => {
    if (!systemMessages) return;
    const systemMessage = _.orderBy(systemMessages, (o) => new Date(o.createDate), ['desc'])[0].message;

    const clean = DOMPurify.sanitize(systemMessage);
    return ReactHtmlParser(clean);
  };

  const handleAdminChangeNow = () => {
    setIsAdminModalOpen(false);
    navigate('/update-password', {
      replace: true,
      state: { username: form.getFieldValue('username').trim() },
    });
  };
  const handleToggleVisibility = () => {
    setVisible(!visible);
  };

  // console.log(Device, 1111111111111111);
  // console.log((window.crypto as Crypto & { randomUUID: () => string }).randomUUID(), 22222222222222);
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        // backgroundColor: 'blue',
        height: '100%',
        border: 0,
        marginLeft: -2,
        borderLeft: '1px solid white',
        paddingTop: '56px',
        paddingBottom: '24px',
        // paddingLeft: '100px',
      }}
      className="loginPagecontent"
    >
      <Card
        style={{
          width: '80%',
          maxWidth: '668px',
          backgroundColor: 'transparent',
          border: 'none',
          height: '100%',
        }}
      >
        <Form layout={'vertical'} form={form} onFinish={onFinish} requiredMark={false}>
          <div style={{ color: '#fff', fontSize: '17px', fontFamily: 'Roboto400', fontWeight: 'bolder' }}>
            {t('login.disclaimer')}
          </div>
          <BoldLabelFormItem
            style={{ marginTop: '20px', marginBottom: '10px', maxWidth: '532px' }}
            label={
              <span style={{ color: 'white', fontSize: '17px', fontFamily: 'Roboto400' }}>
                {t('login.selfDefinedIdLabel')}
              </span>
            }
            name="username"
            rules={[{ required: true, message: t('login.error.required') }]}
          >
            <Input
              className="input"
              size="middle"
              placeholder={t('login.selfDefiendIdTextPlaceholder')}
              style={{
                paddingLeft: 0,
                border: 'none',
                borderBottom: '1px solid white',
                color: 'white',
                fontSize: '20px',
                fontFamily: 'Roboto400',
                backgroundColor: 'transparent',
              }}
            />
          </BoldLabelFormItem>
          <Link
            style={{
              // fontWeight: 'bold',
              // marginLeft: 4,
              fontSize: '17px',
              fontFamily: 'Roboto400',
              marginRight: 4,
              color: 'white',
              textDecoration: 'underline',
            }}
            to="/forgot/login"
          >
            {t('login.forgetSelfDefinedIdLabel')}
          </Link>
          <BoldLabelFormItem
            style={{ marginTop: '30px', marginBottom: '10px', maxWidth: '532px' }}
            label={
              <span style={{ color: 'white', fontSize: '17px', fontFamily: 'Roboto400' }}>
                {t('login.passwordLabel')}
              </span>
            }
            name="password"
            rules={[{ required: true, message: t('login.error.required') }]}
          >
            <div style={{ position: 'relative' }}>
              <Input
                type={visible ? 'text' : 'password'}
                className="input"
                size="middle"
                placeholder={t('login.passwordTextPlaceholder')}
                style={{
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  paddingLeft: 0,
                  border: 'none',
                  borderBottom: '1px solid white',
                  color: 'white',
                  backgroundColor: 'transparent',
                }}
              />
              <img
                src={visible ? eyeOpen : eyeClose}
                alt="toggle visibility"
                style={{ cursor: 'pointer', width: 20, height: 20, position: 'absolute', top: 10, right: 10 }}
                onClick={handleToggleVisibility}
              />
            </div>
          </BoldLabelFormItem>
          <div>
            <Link
              style={{
                // fontWeight: 'bold',
                marginRight: 4,
                // marginLeft: 4,
                fontSize: '17px',
                fontFamily: 'Roboto400',
                color: 'white',

                textDecoration: 'underline',
              }}
              to="/forgot/password"
            >
              {t('login.forgetPasswordLabel')}
            </Link>
          </div>
          {/* {isShowCaptcha && (
            <div style={{ marginTop: 12 }}>
              <GoogleCaptcha
                sitekey={config.captchaSiteKey}
                size="normal"
                theme="light"
                onChange={() => setCaptchaVerified(true)}
                onExpired={onCaptchaError}
                onError={onCaptchaError}
                hl={i18n.language}
              />
            </div>
          )} */}
          <div
            style={{
              // backgroundColor: 'yellow',
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              maxWidth: '532px',
            }}
          >
            <BoldLabelFormItem
              style={{
                // backgroundColor: 'pink',
                maxWidth: '428px',
                width: '100%',
                marginTop: 16,
                display: 'inline-block',
                textAlign: 'center',
              }}
            >
              <Button
                block
                type="default"
                size="large"
                htmlType="submit"
                style={{
                  width: '80%',
                  height: '56px',
                  backgroundColor: 'transparent',
                  border: '1px solid white',
                  color: 'white',
                  fontSize: '20px',
                  fontFamily: 'Roboto500',
                }}
                disabled={!initialized}
                loading={isLoading}
              >
                {t('life.launch.loginBtn')}
              </Button>
            </BoldLabelFormItem>
          </div>
        </Form>

        {/* <div style={{ marginTop: 16, textAlign: 'center' }}>
            {t('life.login.links.forget')}
        
            {t('life.login.links.or')}
           
          </div> */}
        <div
          style={{
            // backgroundColor: 'pink',
            maxWidth: '532px',
            // marginTop: 16,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography.Text type="secondary" style={{ color: 'white', fontSize: '17px', fontFamily: 'Roboto400' }}>
            {t('registration.notRegister')}
            <Link
              style={{
                // fontWeight: 'bold',
                marginRight: 4,
                // marginLeft: 4,
                fontSize: '17px',
                fontFamily: 'Roboto400',
                color: 'white',
                textDecoration: 'underline',
              }}
              to="/register"
            >
              {t('registration.sign')}
            </Link>
            {/* <Markdown>{t('life.login.links.existingMember')}</Markdown> */}
          </Typography.Text>
        </div>
        <div
          style={{
            // backgroundColor: 'yellow',
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 16,
            maxWidth: '532px',
          }}
        >
          {openSnackbar && (
            <div className="custom-alert-login" style={{ width: '100%' }}>
              <Alert
                message={<div className="snackbar" dangerouslySetInnerHTML={{ __html: t(snackbarMessage) }} />}
                type="error"
                // closable
                // onClose={handleCloseSnackbar}
                style={{ marginBottom: 16, width: '100%' }}
              />
            </div>
          )}
        </div>
      </Card>
      <Modal
        open={isModalOpen}
        closable={false}
        title={t('admin.systemAnnouncementMessage.title')}
        footer={<PrimaryButton onClick={() => setIsModalOpen(false)}>{t('common.close')}</PrimaryButton>}
      >
        {isModalOpen && renderSystemMessage()}
      </Modal>
      <Modal
        open={isAdminModalOpen}
        closable={false}
        title={t('admin.password.expired.title')}
        footer={
          <PrimaryButton onClick={() => handleAdminChangeNow()}>{t('admin.password.expired.changeNow')}</PrimaryButton>
        }
      >
        <Trans i18nKey="admin.password.expired.message"></Trans>
      </Modal>
    </div>
  );
}

export default LoginPage;
